import React, { useState, useEffect } from "react";
// import _ from 'lodash';
import './campaigns.css';
import {
    Button,
    Form,
    Col,
    Row,
    Container,
    Card
  } from "react-bootstrap";
import {useForm} from "react-hook-form";
import axios from 'axios';
import SyncLoader from "react-spinners/SyncLoader";
import GenericModal from '../../generic/modal';
import ReactGA from 'react-ga';
// import { Calendar } from "react-modern-calendar-datepicker";
import {main_services_list} from '../../lists/main-services-list';
import DateForm from '../../functions/date-form';
import {timeConverter} from '../view-clinic/modals/time-converter/time-converter';

// eslint-disable-next-line no-extend-native
Date.prototype.yyyymmdd = function() {
    var mm = this.getMonth() + 1; // getMonth() is zero-based
    var dd = this.getDate();
  
    return [this.getFullYear()+"/",
            (mm>9 ? '' : '0') + mm+"/",
            (dd>9 ? '' : '0') + dd
           ].join('');
};

export default function Campaigns(props) {

    
    ReactGA.pageview(window.location.pathname + window.location.search);    
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [success, setSuccess] = useState(Boolean);
    const [service_name, setService_name] = useState(main_services_list[0].value);
    const [title, setTitle] = useState(main_services_list[0].label);
    // const [serviceServerName, setServiceServerName] = useState(main_services_list[0].value);
    const serviceServerName = main_services_list[0].value;
    const [ordinaryPrice, setOrdinaryPrice] = useState("...");
    const [ordinaryPrices, setOrdinaryPrices] = useState("...");
    const today = new Date();
    today.setHours(0,0,0,0);
    const oneDay = 1 * 24 * 60 * 60 * 1000;
    const tomorrow = new Date(today.getTime() + oneDay);
    // console.log(props.location.state.clinicData);

    const [fromDate, setFromDate] = useState(today);
    const [toDate, setToDate] = useState(tomorrow);


    // const defaultFrom = {
    //     year: today.getFullYear(),
    //     month: (today.getMonth()+1),
    //     day: today.getDate(),
    //   };
    //   const defaultTo = {
    //     year: today.getFullYear(),
    //     month: (today.getMonth()+1),
    //     day: (today.getDate()+1),
    //   };
    // const [selectedDayRange, setSelectedDayRange] = useState({
    //     from: defaultFrom,
    //     to: defaultTo,
    // });

    const {register, handleSubmit} = useForm();

    useEffect(() => {
        axios.post('https://uae-dentist-backend.herokuapp.com/account/get-prices', {_id: props.location.state.clinicData.prices} )
        .then((prices) => {
            setOrdinaryPrice(prices.data[serviceServerName]);
            setOrdinaryPrices(prices.data);
        })
        .catch(function (error) {
            console.log(error);
        });
    }, [props.location.state.clinicData, serviceServerName]);

    const handleChange = (treatment) => {
        let parsedTreatment = JSON.parse(treatment);
        setService_name(parsedTreatment.value);
        setTitle(parsedTreatment.label);
        setOrdinaryPrice(ordinaryPrices[parsedTreatment.value]);
    } 

    const onSubmit = async (data) => {
        setLoading(true);
        const postData = {};
        console.log(fromDate);
        console.log(toDate);

        postData.service_name = service_name;
        postData.title = title;
        postData.campaign_price = data.campaignPrice;
        postData.from = fromDate;
        postData.to = toDate;
        postData.clinic_id = props.location.state.clinicData._id;

        if(!(fromDate instanceof Date && !isNaN(fromDate.valueOf()))){
            console.log(fromDate)
            postData.from = timeConverter(fromDate.year, fromDate.month, fromDate.day);
            console.log(postData.from)
        }
        if(!(toDate instanceof Date && !isNaN(toDate.valueOf()))){
            console.log(toDate)
            postData.to = timeConverter(toDate.year, toDate.month, toDate.day);
            console.log(postData.to)
        }

        const token = localStorage.getItem('token');
        const axiosConfig = {
            headers: {
                Authorization: token
            }
        };
        console.log(postData)
        await axios.post('https://uae-dentist-backend.herokuapp.com/account/add-campaign', postData, axiosConfig)
        .then(function (response) {
            // _.extend(props.location.state.clinicData.campaigns, data);
            setSuccess(true);
            setShow(true);
            setLoading(false);
        })
        .catch(function (error) {
            setSuccess(false);
            setShow(true);
            setLoading(false);
            console.log(error);
        })
    } 
    
    return (
        <Container className="mt-5 rounded">
            { show && <GenericModal setShow={setShow} show={show} success={success}/>}
            <Form onSubmit={handleSubmit(onSubmit)}>
            <Row className = "my-5" lg={12}><Col lg={10}>
                <h1>Create campaigns to attract more costumers to your clinic</h1>
            </Col></Row>
            <div className='mt-5'>
                <SyncLoader
                    size={15}
                    margin={2}
                    color={"#123abc"}
                    loading={loading}
                />
            </div>

                <Form.Group  controlId="treatment">
                <Form.Label>Service</Form.Label>
                <Form.Control as="select"  name="services" onChange={(event)=>handleChange(event.target.value)} ref={register ({required:true})} custom>
                {main_services_list.map((treatment, idx) => (
                    <option key={idx} value={JSON.stringify(treatment)}>{treatment.label}</option>
                ))}
                </Form.Control>
                </Form.Group>

                <Form.Group>
                        <Form.Label>{title} Ordinary Price</Form.Label>
                        <Form.Control disabled type='number' name="ordinaryPrice" ref={register} placeholder={ordinaryPrice} />
                </Form.Group>

                <Form.Group>
                        <Form.Label>{title} Campaign Price</Form.Label>
                        <Form.Control required type='number' min="0" step=".01" name="campaignPrice" ref={register ({required:true})} placeholder={'Enter a campaign price'} />
                </Form.Group>
            <Row>
                <Col>
                    <h6>From:</h6>
                    <DateForm setDate={setFromDate} startDate={today} />
                </Col>
                <Col>
                    <h6>To:</h6>
                    <DateForm setDate={setToDate} startDate={tomorrow} />
                </Col>
            </Row>
            <Row>
                <Col>
                    <Button className='my-4 ml-0' variant="primary" type="submit">
                        Create Campaign
                    </Button>
                </Col>
            </Row>
            </Form>
            {/* {main_services_list.map((treatment, idx) => (
                    <option key={idx} value={JSON.stringify(treatment)}>{treatment.label}</option>
            ))} */}
            {props.location.state.clinicData.campaigns &&
            props.location.state.clinicData.campaigns.map((campaign, idx) => (
                <Card>
                <Row key={campaign._id}>
                    <Col>
                        <h6>From: {new Date(campaign.from).yyyymmdd()}</h6>
                    </Col>
                    <Col>
                        <h6>To: {new Date(campaign.to).yyyymmdd()}</h6>
                    </Col>
                    <Col>
                        <h6>Service: {campaign.title}</h6>
                    </Col>
                    <Col>
                        <h6>Price: {campaign.campaign_price}</h6>
                        <Button variant='danger' className='float-right'>
                            Delete
                        </Button>
                    </Col>
                </Row>

                </Card>
            ))
            }
        </Container>
    )
}